import { NAME } from './constants';

export const ADD_MODIFIER = `${NAME}/ADD_MODIFIER`;
export const REMOVE_MODIFIER = `${NAME}/REMOVE_MODIFIER`;
export const CLEAR_MODIFIERS = `${NAME}/CLEAR_MODIFIERS`;
export const RESET = `${NAME}/RESET`;
export const SET_MODIFIER = `${NAME}/SET_MODIFIER`;
export const UNSET_MODIFIER = `${NAME}/UNSET_MODIFIER`;
export const COPY = `${NAME}/COPY`;
